<med-label
  [label]="label"
  [name]="name"
  [disabled]="disabled"
  [required]="required"
  [labelClass]="labelClass"
>
  <div [ngClass]="{ field__container: hasErrorPadding }">
    <div
      class="med-datepicker"
      [ngClass]="{ disabled }"
    >
      <p-calendar
        #fieldRef
        styleClass="med-datepicker__host"
        [name]="name"
        [appendTo]="appendTo ?? 'body'"
        [inputId]="name"
        [disabled]="disabled"
        [required]="required"
        [showTime]="showTime"
        [dateFormat]="pattern"
        [selectionMode]="mode"
        [placeholder]="placeholder"
        [numberOfMonths]="numberOfMonths"
        [inputStyleClass]="'field med-datepicker__field ' + classList"
        [panelStyleClass]="'med-datepicker__panel ' + panelStyleClass"
        [(ngModel)]="value"
        (onBlur)="onBlur.emit($event)"
        (onFocus)="emitFocus($event)"
        (onClose)="onInput.emit(value)"
        (onSelect)="onSelect()"
      ></p-calendar>

      <div class="med-datepicker__nav">
        <div
          class="med-datepicker__icon med-datepicker__icon--delete"
          [ngClass]="{ hide: !hasValue || disabled }"
        >
          <med-icon-x
            *ngIf="!hideClearBtn"
            size="14"
            (click)="clear()"
          ></med-icon-x>
        </div>

        <div class="med-datepicker__icon med-datepicker__icon--calendar">
          <med-icon-calendar-days
            size="16"
            (click)="fieldRef.toggle()"
          ></med-icon-calendar-days>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="invalid"
    class="field__error-message up"
  >
    {{ errorMessage }}
  </div>
</med-label>
